import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const { readDataByFilter } = useEntityCrud('Question/getAll');
    const { statusData } = useEntityCrud('Question/ChangeStatus');

    const { id } = useParams();
    const navigate = useNavigate();

    const { readData: readDataOpinionFactor } = useEntityCrud('OpinionFactor/getAll')
    const [opinionFactorList, setOpinionFactorList] = useState([]);
    useEffect(() => {
        readDataOpinionFactor().then(res => {
            setOpinionFactorList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.status })))
        });
    }, [])

    const [rows, setRows] = useState([]);


    useEffect(() => {
        const postedData = {
            "opinionId": id,
        };
        readDataByFilter(postedData).then(({ data }) => {
            setRows(data.result);
        })
    }, [])


    const deActiveRow = (itemId, title, factorId) => {
         
        const postedData = {
            id: itemId,
            status: false,
            opinionId: id,
            title: title,
            factorId
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' پرسش مورد نظر با موفقیت غیر فعال شد');
                const postedData = {
                    "opinionId": id,
                };
                readDataByFilter(postedData).then(({ data }) => {
                    setRows(data.result);
                })
            } else
                toast.error(data.message);
        });
    }

    const activeRow = (itemId, title, factorId) => {
         
        const postedData = {
            id: itemId,
            status: true,
            opinionId: id,
            title: title,
            factorId
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' پرسش مورد نظر با موفقیت  فعال شد');
                const postedData = {
                    "opinionId": id,
                };
                readDataByFilter(postedData).then(({ data }) => {
                    setRows(data.result);
                })
            } else
                toast.error(data.message);
        });
    }

    const handleBack = () => {
        navigate('/survey', { replace: true });
    }



    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">پرسش ها</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>

            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to={'/survey/surveyQuestion/create/' + id}>ایجاد پرسش</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length > 0 ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>معیار نظرسنجی</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title || '-'}</td>
                                <td>{opinionFactorList?.find(it => it.value === item.factorId)?.label || '-'}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} title="ویرایش" className="btn btn-icon mb-0 btn-primary"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('delete') ? (item.status ? <button title="غیرفعال سازی" onClick={e => deActiveRow(item.id, item.title, item.factorId)}
                                        className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button>
                                        : <button onClick={e => activeRow(item.id, item.title, item.factorId)} className="btn btn-icon mb-0 btn-success" title="فعال سازی">
                                            <i className="fe fe-check"></i></button>) : ''}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> :
                    <div className='alert alert-info'>
                        <p>
                            پرسشی تعریف نشده است ! 
                        </p>
                    </div>
                }
            </div>
        </div>
    );
}

export default Index;